import { Component, OnInit, ViewChild } from "@angular/core";
import { StripeSource } from "stripe-angular";
import { SubscriptionService } from "./subscription.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import * as CryptoJS from "crypto-js";
import { environment } from "./../../environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { Title } from "@angular/platform-browser";
import { NgForm } from "@angular/forms";
import * as moment from "moment";
declare var _rfsn: any;

@Component({
  selector: "app-subscription",
  templateUrl: "./subscription.component.html",
  styleUrls: ["./subscription.component.css"],
})
export class SubscriptionComponent implements OnInit {
  showPromocode = true;
  hide: boolean = false;
  isLoading: boolean = false;
  step_2: boolean = false;
  step_1: boolean = true;
  errorShow: boolean = false;
  step: any = 1;
  invalidCouponMessage: string;
  invalidCoupon: boolean = false;
  validCoupon: boolean = false;
  discount: any;
  userInfo: any;
  isPromocode: boolean = true;
  invalidError: any;
  cardReady = false;
  extraData = {
    //name: "ajay",
  };
  model: any = {};
  encryptedData: string;
  userinfo: any;
  sub: any;
  language: any;
  publicId: any;
  decodeUrl: any;
  plan: any;
  btnDisable = false;
  subscription: any;
  planDetail: any;
  @ViewChild("subscriptionForm") form: any;
  @ViewChild("stripeCard") stripe: any;
  planArrayLimit: number = 4;
  payableAmout: any;
  changeIndex: any;
  constructor(
    private homeService: SubscriptionService,
    private route: Router,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private router: ActivatedRoute,
    private translate: TranslateService,
    private titleService: Title
  ) {
    if (!localStorage.getItem(environment.localStorageKey)) {
      this.route.navigate(["/login"]);
    }

    this.sub = this.router.queryParams.subscribe((params: any) => {
      this.publicId = params.public_id;
      if (params.planId == 1) {
        this.model.stripe_plan_id = environment.monthPlanId;
      } else if (params.planId == 2) {
        this.model.stripe_plan_id = environment.yearPlanId;
      } else if (params.planId == 3) {
        this.model.stripe_plan_id = environment.premiumPlanId;
      } else if (params.planId == 4) {
        this.model.stripe_plan_id = environment.superPlanId;
      }
    });
  }

  ngOnInit(): void {
    if (localStorage.getItem(environment.localStorageLangKey)) {
      this.language = JSON.parse(
        localStorage.getItem(environment.localStorageLangKey)
      );
      this.translate.use(this.language);
      this.translate.use(this.language);
      if (this.language == "en") {
        // this.titleService.setTitle(environment.localStorageKey);
      } else {
        // this.titleService.setTitle("Perro desatado");
      }
    }
    if (localStorage.getItem(environment.localStorageKey)) {
      this.encryptedData = localStorage.getItem(environment.localStorageKey);
      this.userinfo = JSON.parse(
        CryptoJS.AES.decrypt(
          this.encryptedData,
          environment.secretkey
        ).toString(CryptoJS.enc.Utf8)
      );

      // if (this.userinfo.subscription_type) {
      //   this.route.navigate(["/my-account/my-subscription"]);
      // }
    }
    this.translate.onLangChange.subscribe((e: any) => {
      // this.titleService.setTitle(e.translations.PAGE_TITLE);
    });
    window.scrollTo(0, 0);
    this.subscriptionPlanInfo();
  }

  subscriptionPlanInfo() {
    this.spinner.show();
    this.homeService.subscriptionPlanInfo().subscribe(
      (res: any) => {
        this.subscription = res.results;
        if (this.model.stripe_plan_id) {
          const index = this.subscription
            .map((el) => {
              return el.plan_id;
            })
            .indexOf(this.model.stripe_plan_id);
          if (index != -1) {
            this.selectPlan(this.subscription[index], index);
          }
        }
        this.spinner.hide();
      },
      (err) => {
        this.toastr.error(err.error.message, "OOPS!", {
          closeButton: true,
        });
        this.spinner.hide();
      }
    );
  }

  viewMore(index: any) {
    this.changeIndex = index;
    this.planArrayLimit = this.subscription[
      this.changeIndex
    ].description.feature.length;
  }
  selectPlan(plan, i) {
    this.plan = i + 1;
    this.model.stripe_plan_id = plan.plan_id;
    this.planDetail = plan;
    this.step_1 = false;
    this.step_2 = true;
  }
  toggleShow(plan) {
    this.plan = plan;
    this.step_2 = !this.step_2;
    this.step_1 = !this.step_1;
    this.step = this.step + 1;
    if (plan == 1) {
      // this.model.stripe_plan_id = "price_1HPkGpA8lqZeqjmXs1kH6j1o";
      this.model.stripe_plan_id = environment.monthPlanId;
    }
    // else if (plan == 3) {
    //   this.model.stripe_plan_id = environment.premiumPlanId;
    // }
    else {
      //this.model.stripe_plan_id = "price_1HPkHiA8lqZeqjmXgp5UnGLN";
      this.model.stripe_plan_id = environment.yearPlanId;
    }
  }
  planShow(Form: NgForm) {
    this.hide = false;
    this.step_1 = true;
    this.step_2 = false;
    this.step = 1;
    this.model = {};
    this.isPromocode = true;
    this.planDetail = "";
    this.discount = "";
    this.invalidCoupon = false;
    this.validCoupon = false;
  }

  getToken() {
    if (this.form.valid) {
      this.btnDisable = true;
      this.stripe.createToken();
    }
  }
  onStripeInvalid(error: Error) {}

  setStripeToken(token: stripe.Token) {
    this.spinner.show();
    this.errorShow = true;
    this.model.source = token.id;
    if (this.model.card_holder_name && this.form.valid) {
      this.btnDisable = false;
      setTimeout(() => {
        if (this.userinfo.subscription_type) {
          if (this.userinfo.payment_gateway != "apple") {
            this.upgradePlan(true);
          } else {
            this.stripe = "";
            this.btnDisable = false;
            this.spinner.hide();
            this.toastr.error(
              "Please upgrade our plan from our mobile App",
              "Info!",
              {
                closeButton: true,
              }
            );
            this.form.reset();
          }
        } else {
          this.addSubscription(true);
        }
      }, 1000);
    } else {
      this.spinner.hide();
    }
  }

  setStripeSource(source: StripeSource) {}

  onStripeError(error: Error) {
    this.stripe = "";
    this.btnDisable = false;
    this.spinner.hide();
    this.toastr.error(error.message, "OOPS!", {
      closeButton: true,
    });
  }
  /**
   * Apply promo code
   */
  applyPromoCode() {
    this.isLoading = true;
    const coupon_title = this.model.promocode;
    //this.spinner.show();
    this.homeService.promoCode(coupon_title).subscribe(
      (data) => {
        if (data) {
          this.hide = true;
          this.isLoading = false;
          this.validCoupon = true;
          this.invalidCoupon = false;
          this.model.stripe_coupon_id = data.stripe_coupon_id;
          this.model.coupon_id = data.id;
          this.model.Applied_code = data.name;
          this.isPromocode = false;
          if (this.plan == 1) {
            if (data.percent_off) {
              this.discount = (9.99 * data.percent_off) / 100;

              // this.discountPrice = 29 - this.discount;
            } else {
              if (data.amount_off) {
                this.discount = data.amount_off / 100;
                // this.discountPrice = 29 - this.discount;
              } else {
                this.discount = data.discount_amount;
              }
            }
          } else if (this.plan == 2) {
            if (data.percent_off) {
              this.discount = (49.99 * data.percent_off) / 100;
              // this.discountPrice = 299 - this.discount;
            } else {
              if (data.amount_off) {
                this.discount = data.amount_off / 100;
                // this.discountPrice = 299 - this.discount;
              } else {
                this.discount = data.discount_amount;
              }
            }
          } else if (this.plan == 3) {
            if (data.percent_off) {
              this.discount = (149.99 * data.percent_off) / 100;
              // this.discountPrice = 299 - this.discount;
            } else {
              if (data.amount_off) {
                this.discount = data.amount_off / 100;
                // this.discountPrice = 299 - this.discount;
              } else {
                this.discount = data.discount_amount;
              }
            }
          } else if (this.plan == 4) {
            if (data.percent_off) {
              this.discount = (599.99 * data.percent_off) / 100;
              // this.discountPrice = 299 - this.discount;
            } else {
              if (data.amount_off) {
                this.discount = data.amount_off / 100;
                // this.discountPrice = 299 - this.discount;
              } else {
                this.discount = data.discount_amount;
              }
            }
          }
          this.model.discount_amount = this.discount.toFixed(2);
        }
      },
      (err) => {
        if (err.status === 404) {
          this.invalidCoupon = true;
          this.isLoading = false;
          this.invalidCouponMessage = err.error.message;
        } else {
          this.isLoading = false;
          this.invalidCoupon = true;
          this.invalidCouponMessage = "The coupon you entered is not valid.";
        }
      }
    );
  }
  /**
   * Close promo code
   */
  closePromoCode() {
    this.hide = false;
    this.validCoupon = false;
    this.model.promocode = "";
    this.model.stripe_coupon_id = "";
    this.discount = "";
    this.isPromocode = true;
  }
  /**
   * Add subscription plan
   */
  addSubscription(form) {
    if (form) {
      this.btnDisable = true;
      //this.spinner.show();
      this.homeService.add_subscription(this.model).subscribe(
        (data) => {
          this.btnDisable = false;
          if (data) {
            this.userinfo.subscription_type = data.subscription_type;
            this.userinfo.subscription_date = moment(
              data.start_date * 1000
            ).format("YYYY-MM-DD");
            const promo = CryptoJS.AES.encrypt(
              JSON.stringify(this.userinfo),
              environment.secretkey
            ).toString();
            localStorage.setItem(environment.localStorageKey, promo);
            this.spinner.hide();
            this.toastr.success(data.message, "Success!", {
              closeButton: true,
            });
            if (this.publicId) {
              this.decodeUrl = JSON.parse(
                CryptoJS.AES.decrypt(
                  this.publicId,
                  environment.secretkey
                ).toString(CryptoJS.enc.Utf8)
              );
              this.decodeUrl = decodeURIComponent(this.decodeUrl);
              this.route.navigate([this.decodeUrl]);
            } else {
              this.route.navigate(["/my-account/profile"]);
            }
          }
        },
        (err) => {
          this.btnDisable = false;
          if (err.error.code == 500) {
            this.spinner.hide();
            this.toastr.error("Invalid card detail.", "OOPS!", {
              closeButton: true,
            });
            //Incorrect integer value: 'cus_I0Xik2wsc9XKVb
          } else if (err.error.code == "card_declined") {
            this.spinner.hide();
            this.toastr.error("Invalid card detail.", "OOPS!", {
              closeButton: true,
            });
            //Your card was declined. Your request was in test mode, but used a non test (live) card. For a list of valid test cards, visit: https://stripe.com/docs/testing.
          } else if (err.error.code == "resource_missing") {
            this.spinner.hide();
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
            //No such price: 'price_1HQ9FTA8lqZeqjmXmdky8SjM222
          } else if (err.error.code == "expired_card") {
            this.spinner.hide();
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
            //Your card has expired
          } else if (err.error.code == "incorrect_cvc") {
            this.spinner.hide();
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
            //Your card's security code is incorrect.
          } else if (err.error.code == "processing_error") {
            this.spinner.hide();
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
            //An error occurred while processing your card. Try again in a little bit.
          } else if (err.error.code == "incorrect_number") {
            this.spinner.hide();
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
          } else if (err.error.code == "risk_level") {
            this.spinner.hide();
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
          } else {
            this.spinner.hide();
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
          }
        }
      );
    }
  }
  upgradePlan(form) {
    if (form) {
      this.btnDisable = true;
      //this.spinner.show();
      this.homeService.upgrade_subscription(this.model).subscribe(
        (data) => {
          this.btnDisable = false;
          if (data) {
            this.userinfo.subscription_type = data.subscription_type;
            this.userinfo.subscription_date = moment(
              data.start_date * 1000
            ).format("YYYY-MM-DD");
            const promo = CryptoJS.AES.encrypt(
              JSON.stringify(this.userinfo),
              environment.secretkey
            ).toString();
            localStorage.setItem(environment.localStorageKey, promo);
            this.spinner.hide();
            this.toastr.success(data.message, "Success!", {
              closeButton: true,
            });
            if (this.publicId) {
              this.decodeUrl = JSON.parse(
                CryptoJS.AES.decrypt(
                  this.publicId,
                  environment.secretkey
                ).toString(CryptoJS.enc.Utf8)
              );
              this.decodeUrl = decodeURIComponent(this.decodeUrl);
              this.route.navigate([this.decodeUrl]);
            } else {
              this.route.navigate(["/my-account/profile"]);
            }
          }
        },
        (err) => {
          this.btnDisable = false;
          if (err.error.code == 500) {
            this.spinner.hide();
            this.toastr.error("Invalid card detail.", "OOPS!", {
              closeButton: true,
            });
            //Incorrect integer value: 'cus_I0Xik2wsc9XKVb
          } else if (err.error.code == "card_declined") {
            this.spinner.hide();
            this.toastr.error("Invalid card detail.", "OOPS!", {
              closeButton: true,
            });
            //Your card was declined. Your request was in test mode, but used a non test (live) card. For a list of valid test cards, visit: https://stripe.com/docs/testing.
          } else if (err.error.code == "resource_missing") {
            this.spinner.hide();
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
            //No such price: 'price_1HQ9FTA8lqZeqjmXmdky8SjM222
          } else if (err.error.code == "expired_card") {
            this.spinner.hide();
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
            //Your card has expired
          } else if (err.error.code == "incorrect_cvc") {
            this.spinner.hide();
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
            //Your card's security code is incorrect.
          } else if (err.error.code == "processing_error") {
            this.spinner.hide();
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
            //An error occurred while processing your card. Try again in a little bit.
          } else if (err.error.code == "incorrect_number") {
            this.spinner.hide();
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
          } else if (err.error.code == "risk_level") {
            this.spinner.hide();
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
          } else {
            this.spinner.hide();
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
          }
        }
      );
    }
  }
}
